export default "/images/cef4436f680c64d1602a1f2d449b4437.avif";